import { ICON_STYLES } from './constants';

export const getIconStyles = (state, selected) =>
  selected ? ICON_STYLES.selected : ICON_STYLES[state] || ICON_STYLES.notSelected;

export const isSelected = (numberOfStep, selectedStep) => numberOfStep === selectedStep;

export const getLabel = (number, title) => `${number + 1}° `.concat(title);
